import { createElement, forwardRef } from 'react';
import * as icons from '@ant-design/icons';
const createFromIconfontCN = icons.createFromIconfontCN;
const Icon = (props, ref) => {
    const { type = '', size, color, ...rest } = props;
    const IconComp = (icons || {})[type];
    const style = {
        ...rest.style,
        fontSize: size,
        color,
    };
    if (!IconComp) {
        const IconFont = createFromIconfontCN();
        return createElement(IconFont, Object.assign({ type: type }, rest, { style: style, ref: ref }));
    }
    return createElement(IconComp, Object.assign({}, rest, { style: style, twoToneColor: color, ref: ref }));
};
Icon.displayName = 'Icon';
export default forwardRef(Icon);
